import { Text } from '@avanta/shared/components/Text';
import { Skeleton } from '@avanta/shared/components/ui/Skeleton';

interface PageHeaderProps {
  title: string;
  description?: string;
  isDescriptionLoading?: boolean;
  className?: string;
  titleAdornment?: React.ReactNode;
}

const splitByNumbers = (text: string): Array<{ part: string; isNumber: boolean }> =>
  text.split(/(\d+(?:[.,]\d+)*)/).map((part, index) => ({
    part,
    isNumber: index % 2 !== 0,
  }));

export const PageHeader = ({
  title,
  description,
  isDescriptionLoading = false,
  className,
  titleAdornment,
  children,
}: React.PropsWithChildren<PageHeaderProps>): React.ReactElement => (
  <header className={className}>
    <div className="flex flex-wrap items-start justify-between gap-4">
      <div className="min-w-0 max-w-3/5">
        <div className="flex items-center gap-1">
          <Text tag="h1" variant="heading-xl-medium" className="text-denim-800 line-clamp-1">
            {title}
          </Text>
          {titleAdornment}
        </div>
        {description && (
          <Text tag="div" variant="text-sm-regular" className="text-gray-400 line-clamp-1 mt-2">
            {isDescriptionLoading
              ? splitByNumbers(description).map(({ part, isNumber }, index) =>
                  isNumber ? (
                    <Skeleton
                      key={index}
                      className="inline-block h-4 w-5 align-middle"
                      aria-hidden="true"
                    />
                  ) : (
                    part
                  )
                )
              : description}
          </Text>
        )}
      </div>
      {children ? (
        <div className="flex shrink-0 items-center gap-2 -mt-2 am-7xl:-mt-4">{children}</div>
      ) : null}
    </div>
  </header>
);
